(() => {
  const node = document.getElementById('nm-retarget-config');
  if (!node || window.NmRetarget) return;
  const config = JSON.parse(node.textContent);
  const repeatTest = config.repeatTest === true && Number.isFinite(config.duration) && config.duration > 0;
  const root = window.Shopify?.routes?.root || '/';
  const key = 'nimavo_regresa30_deadline_v2';
  const legacyKey = 'nimavo_regresa30_deadline_v1';
  const appliedKey = legacyKey + '_applied';
  const url = new URL(location.href);
  const eligible = url.searchParams.get('nm_offer') === config.id;
  const codes = new Set(config.codes);
  const upper = value => String(value || '').trim().toUpperCase();
  const own = code => codes.has(upper(code));
  const read = name => { try { return localStorage.getItem(name); } catch { return null; } };
  const write = (name, value) => { try { localStorage.setItem(name, String(value)); } catch {} };
  const api = window.NmRetarget = { active: false, blocking: false, ready: false };
  const queryCodes = () => (new URL(location.href).searchParams.get('discount') || '').split(',').filter(Boolean);
  if (!eligible && !config.cartHasPromotion && read(appliedKey) !== 'true' && !queryCodes().some(own)) return;
  const banner = document.getElementById('nm-retarget-promotion');
  const label = banner.querySelector('[data-rt-label]');
  const clock = banner.querySelector('[data-rt-clock]');
  const detail = banner.querySelector('[data-rt-detail]');
  const retry = banner.querySelector('[data-rt-retry]');
  const status = banner.querySelector('[data-rt-status]');
  const money = amount => new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(amount / 100);
  const original = new Map();
  const originalData = new Map();
  const readDeadline = name => Number(read(name)) || Number(document.cookie.split('; ').find(value => value.startsWith(name + '='))?.split('=')[1]) || 0;
  let deadline = readDeadline(key);
  if (!deadline) {
    const previous = readDeadline(legacyKey);
    if (previous) {
      deadline = previous + config.duration - 64800000;
      write(key, deadline);
      document.cookie = key + '=' + deadline + '; Max-Age=31536000; Path=/; SameSite=Lax; Secure';
    }
  }
  let serverTime;
  let serverAnchor;
  let busy = false;
  let queued = false;
  let failed = false;
  let unsupported = false;
  let tick;
  let deferred;
  let verifiedTotal = -1;
  const now = () => serverTime === undefined ? Date.now() : serverTime + performance.now() - serverAnchor;
  const persistDeadline = value => {
    write(key, value);
    document.cookie = key + '=' + value + '; Max-Age=31536000; Path=/; SameSite=Lax; Secure';
    if (Number(read(key)) !== value && !document.cookie.includes(key + '=' + value)) throw new Error('Storage unavailable');
    deadline = value;
  };
  const renewDeadline = () => {
    if (!repeatTest || !eligible || !deadline || deadline > now()) return;
    const current = now();
    const previous = Math.max(deadline, readDeadline(key));
    const next = previous > current ? previous : previous + (Math.floor((current - previous) / config.duration) + 1) * config.duration;
    persistDeadline(next);
  };
  const cartElement = () => document.querySelector('nm-cart');
  const cartBusy = () => { const cart = cartElement(); return cart?.busy || cart?.pending?.size || cart?.refreshing; };
  const closeCod = () => document.querySelector('#rsi_form_wrapper[open] .rsi-form-close-button')?.click();
  const setText = (element, text) => {
    if (!element) return;
    if (!original.has(element)) original.set(element, element.textContent);
    element.textContent = text;
  };
  const setData = (element, name, value) => {
    if (!originalData.has(element)) originalData.set(element, {});
    const data = originalData.get(element);
    if (!(name in data)) data[name] = element.dataset[name];
    element.dataset[name] = String(value);
  };
  const restorePrices = () => {
    for (const [element, value] of original) if (element.isConnected) element.textContent = value;
    for (const [element, data] of originalData) for (const [name, value] of Object.entries(data)) {
      if (value === undefined) delete element.dataset[name]; else element.dataset[name] = value;
    }
    original.clear(); originalData.clear();
    document.querySelectorAll('[data-nm-product] input[name="quantity"]:checked').forEach(radio => radio.dispatchEvent(new Event('change', { bubbles: true })));
  };
  const showPrices = () => {
    document.querySelectorAll('[data-nm-product]').forEach(section => {
      const sticky = section.querySelector('[data-nm-sticky]');
      const comparison = Number(sticky?.dataset.comparePrice || 0);
      setText(section.querySelector('.price-line > strong'), money(config.prices[0]));
      const badge = section.querySelector('.price-line .price-tag');
      if (badge && comparison > config.prices[0]) setText(badge, badge.textContent.replace(/\d+%/, Math.floor((comparison - config.prices[0]) * 100 / comparison) + '%'));
      section.querySelectorAll('input[name="quantity"]').forEach(radio => {
        const price = config.prices[Number(radio.value) - 1];
        if (!price) return;
        const card = radio.closest('.bundle-option');
        setData(radio, 'total', price);
        setText(card.querySelector('.bundle-price > strong'), money(price));
        setText(card.querySelector('.bundle-savings'), config.strings.save + ' ' + money(Number(radio.dataset.compare) - price));
      });
      if (sticky) setData(sticky, 'unitPrice', config.prices[0]);
      section.querySelector('input[name="quantity"]:checked')?.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };
  const decorate = destination => {
    const next = new URL(destination, location.origin);
    if (api.active && next.origin === location.origin && (next.pathname === root || /\/(cart|products\/manta-calefactora)\/?$/.test(next.pathname))) {
      next.searchParams.set('nm_offer', config.id);
      next.searchParams.delete('nm_promo');
    }
    return next.href;
  };
  api.cartUrl = decorate;
  const appliedCodes = cart => {
    const values = (cart.discount_codes || []).map(item => typeof item === 'string' ? item : item.code);
    const allocations = [...(cart.cart_level_discount_applications || []), ...(cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))];
    allocations.forEach(application => {
      if (application?.type !== 'discount_code') return;
      const index = config.titles.indexOf(application.title);
      values.push(index >= 0 ? config.codes[index] : application.code || application.title);
    });
    return [...new Set(values.map(upper).filter(Boolean))];
  };
  async function request(path, body) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(root + path, { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) }, ...(body ? { body: JSON.stringify(body) } : {}), signal: controller.signal });
      if (!response.ok) throw new Error('Promotion unavailable');
      const date = Date.parse(response.headers.get('Date'));
      if (Number.isFinite(date)) { serverTime = date; serverAnchor = performance.now(); }
      return await response.json();
    } finally { clearTimeout(timeout); }
  }
  function draw() {
    clearTimeout(tick);
    if (api.active && repeatTest) {
      try { renewDeadline(); }
      catch {
        failed = true; api.active = false; api.ready = false; api.blocking = true; closeCod();
        status.textContent = config.strings.error;
      }
    }
    if (!eligible && !failed) { banner.hidden = true; return; }
    banner.hidden = false;
    retry.hidden = !failed;
    clock.hidden = !api.active || !api.ready || unsupported;
    detail.hidden = !api.active || unsupported;
    label.textContent = failed ? config.strings.error : api.blocking ? config.strings.busy : unsupported ? config.strings.packs : api.active ? config.strings.active : config.strings.expired;
    if (api.active && deadline) {
      const seconds = Math.max(0, Math.ceil((deadline - now()) / 1000));
      clock.textContent = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60].map(n => String(n).padStart(2, '0')).join(':');
      if (!seconds) { api.active = false; api.blocking = true; api.ready = false; closeCod(); restorePrices(); sync(); }
      else tick = setTimeout(draw, 1000);
    }
  }
  async function sync() {
    if (busy) { queued = true; return; }
    if (cartBusy()) { deferred = setTimeout(sync, 150); return; }
    busy = true; api.blocking = true; api.ready = false; failed = false; draw();
    try {
      let cart = await request('cart.js');
      if (eligible && !deadline) {
        persistDeadline(now() + config.duration);
      }
      renewDeadline();
      api.active = eligible && deadline > now();
      if (api.active) showPrices(); else restorePrices();
      const blankets = cart.items.filter(item => Number(item.product_id) === config.productId);
      const quantity = blankets.reduce((sum, item) => sum + item.quantity, 0);
      unsupported = api.active && quantity > 3;
      const desired = api.active && quantity >= 1 && quantity <= 3 ? config.codes[quantity - 1] : '';
      const currentCodes = appliedCodes(cart);
      const promoCodes = currentCodes.filter(own);
      const blanketTotal = blankets.reduce((sum, item) => sum + item.final_line_price, 0);
      const correct = desired && blanketTotal === config.prices[quantity - 1] && promoCodes.includes(desired) && promoCodes.length === 1;
      const needsUpdate = desired ? !correct : promoCodes.length > 0;
      const next = new URL(location.href);
      let keep = currentCodes.filter(code => !own(code));
      if (needsUpdate) {
        closeCod();
        if (desired) keep = [desired];
        cart = await request('cart/update.js', { discount: keep.join(',') });
        const total = cart.items.filter(item => Number(item.product_id) === config.productId).reduce((sum, item) => sum + item.final_line_price, 0);
        if (desired && total !== config.prices[quantity - 1]) throw new Error('Promotion price unavailable');
        if (!desired && appliedCodes(cart).some(own)) throw new Error('Regular prices unavailable');
        write(appliedKey, Boolean(desired));
        if (keep.length) next.searchParams.set('discount', keep.join(',')); else next.searchParams.delete('discount');
        if (eligible) next.searchParams.delete('nm_promo');
        if (cartElement()) { location.replace(next.href); return; }
        history.replaceState(history.state, '', next);
      } else if (desired && !queryCodes().map(upper).includes(desired)) {
        next.searchParams.set('discount', desired);
        next.searchParams.delete('nm_promo');
        location.replace(next.href); return;
      } else if (!desired) {
        const retained = queryCodes().filter(code => !own(code));
        if (retained.length) next.searchParams.set('discount', retained.join(',')); else next.searchParams.delete('discount');
        history.replaceState(history.state, '', next);
        write(appliedKey, false);
      }
      verifiedTotal = cart.total_price;
      api.ready = true; api.blocking = false;
      cartElement()?.tryAutoOrder?.();
    } catch {
      failed = true; api.ready = false; api.blocking = true; closeCod();
      status.textContent = config.strings.error;
    } finally {
      busy = false; draw();
      if (queued) { queued = false; deferred = setTimeout(sync, 150); }
    }
  }
  api.blocking = true;
  if (eligible) {
    url.searchParams.delete('nm_promo');
    history.replaceState(history.state, '', url);
    const header = document.querySelector('nm-cart .nm-cart-header');
    if (header) header.after(banner); else document.body.prepend(banner);
    banner.hidden = false;
    document.querySelectorAll('[data-nm-cart-timer]').forEach(timer => { timer.hidden = true; });
  }
  retry.addEventListener('click', sync);
  document.addEventListener('click', event => {
    const checkout = event.target.closest?.('#rsi_buy_now_button,.rsi-submit_button,[name="checkout"]');
    if (checkout && (api.blocking || !api.ready || (api.active && ((!repeatTest && deadline <= now()) || Number(cartElement()?.dataset.total) !== verifiedTotal || cartBusy())))) {
      event.preventDefault(); event.stopImmediatePropagation(); closeCod(); sync(); return;
    }
    if (api.active) {
      const link = event.target.closest?.('a[href]');
      if (link) link.href = decorate(link.href);
      if (event.target.closest?.('[data-nm-cart-step],[data-nm-cart-remove]')) { api.ready = false; api.blocking = true; closeCod(); }
    }
  }, true);
  document.addEventListener('submit', event => {
    if (!event.target.matches?.('form.nm-form')) return;
    if (api.blocking || !api.ready || (api.active && !repeatTest && deadline <= now())) { event.preventDefault(); event.stopImmediatePropagation(); sync(); }
  }, true);
  document.addEventListener('change', event => {
    if (api.active && event.target.matches?.('[data-nm-cart-quantity]')) { api.ready = false; api.blocking = true; closeCod(); }
  }, true);
  document.addEventListener('cart:updated', () => { api.ready = false; api.blocking = true; clearTimeout(deferred); deferred = setTimeout(sync, 150); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) sync(); });
  window.addEventListener('pageshow', event => { if (event.persisted) sync(); });
  window.addEventListener('storage', event => { if (event.key === key) { deadline = Number(event.newValue) || deadline; sync(); } });
  if (eligible) {
    const protectQuantity = () => {
      const form = document.querySelector('#rsi_form_wrapper[open]');
      if (!form || !api.active) return;
      form.querySelectorAll('.rsi-quantity-input').forEach(input => { input.readOnly = true; input.setAttribute('aria-readonly', 'true'); });
      form.querySelectorAll('.rsi-quantity-decrease,.rsi-quantity-increase').forEach(button => { button.disabled = true; });
    };
    const observer = new MutationObserver(protectQuantity);
    observer.observe(document.body, { childList: true, subtree: true });
  }
  sync();
})();
